// src/pages/Ingredient.jsx
import React, { useState, useEffect, useRef } from "react";
import { Form, Image, Modal, Button } from "react-bootstrap";
import { Card, CardBody } from "./../../components/card/card.jsx";
import Select from "react-select";
// import { dateOptions } from "./../../components/selectvalues/selectvalue.jsx";
import glassshimmer from "../../assets/images/glassshimmer.png";
import Pagination from "./../../components/pagination/Pagination.jsx";
import { useDispatch, useSelector } from "react-redux";
import { fetchIngredientsPageInfo, fetchRecipeIngredientsAnalytics } from "../../actions/ingredients_actions";

const Ingredient = () => {
  const dispatch = useDispatch();
  const debounceRef = useRef(null);

  //Modal related
  const recipeIngredients = useSelector(
    (state) => state.ingredients.recipeIngredients
  );
  const loadingRecipeIngredients = useSelector(
    (state) => state.ingredients.loadingRecipeIngredients
  );
  const recipeIngredientsError = useSelector(
    (state) => state.ingredients.recipeIngredientsError
  );

  const [showRecipeModal, setShowRecipeModal] = useState(false);
  const [selectedRecipeId, setSelectedRecipeId] = useState(null);
  const [selectedRecipeName, setSelectedRecipeName] = useState("");

  const handleCocktailClick = (recipe) => {
    if (!recipe?.id) return;
    setSelectedRecipeId(recipe.id);
    setSelectedRecipeName(recipe.name || "Recipe Details");
    setShowRecipeModal(true);
    dispatch(fetchRecipeIngredientsAnalytics(recipe.id));
  };




  const dateOptions = [
    { value: 5, label: 'Daily', desc: 'Days' },
    { value: 2, label: 'Weekly', desc: 'Weeks' },
    { value: 1, label: 'Monthly', desc: 'Months' },
    { value: 0, label: 'Yearly', desc: 'Years' },
  ];

  const ingredientsPageInfo = useSelector(
    (state) => state.ingredients.ingredientsPageInfo
  );
  const ingredientsLoading = useSelector(
    (state) => state.ingredients.loadingIngredientsPageInfo
  );
  const ingredientsError = useSelector(
    (state) => state.ingredients.ingredientsPageInfoError
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [currentTab, setCurrentTab] = useState("viewed");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTable, setSelectedTable] = useState(0); // 0 = Liquor, 1 = Mixer
  const [ingredientselectedDateOption, setIngredientSelectedDateOption] =
    useState(dateOptions[1]); // Weekly default
  const [ingredientTopCount, setIngredientTopCount] = useState(10);

  const themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();

  const producttabs = [
    { id: "viewed", label: "Viewed" },
    { id: "crafted", label: "Crafted" },
    { id: "liked", label: "Liked" },
  ];

  const getFilterValue = (tab) => {
    switch (tab) {
      case "viewed":
        return 0;
      case "crafted":
        return 2;
      case "liked":
        return 3;
      default:
        return 0;
    }
  };

  const intervalMap = {
    5: "daily",
    2: "weekly",
    1: "monthly",
    0: "yearly",
  };

  const getFilteredItems = (items) =>
    (items || []).filter((item) =>
      item?.details?.name
        ?.toLowerCase()
        ?.includes((searchTerm || "").toLowerCase())
    );

  const baseFiltered = getFilteredItems(ingredientsPageInfo);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginated = baseFiltered.slice(indexOfFirstItem, indexOfLastItem);

  const getTotalItems = () => baseFiltered.length;
  const getCurrentRange = () => {
    const start = indexOfFirstItem + 1;
    const end = Math.min(indexOfLastItem, getTotalItems());
    return `${start}-${end}`;
  };

  const IngredientTileInfo = (
    filterValue,
    table = selectedTable,
    interval = intervalMap[ingredientselectedDateOption?.value] || "weekly",
    top = ingredientTopCount
  ) => {
    dispatch(
      fetchIngredientsPageInfo({
        filter: String(filterValue),
        table: String(table),
        interval,
        top: String(top),
      })
    );
  };


  // Track last fetched params (stringified) to skip identical queries
  const lastFetchedKeyRef = useRef(null);

  // Build the params we send to the backend (exclude searchTerm on purpose;
  // search is still client-side in your current implementation)
  const currentParams = React.useMemo(() => {
    const filter = String(getFilterValue(currentTab));
    const interval = intervalMap[ingredientselectedDateOption?.value] || "weekly";
    return {
      filter,
      table: String(selectedTable),
      interval,
      top: String(ingredientTopCount),
    };
  }, [
    currentTab,
    selectedTable,
    ingredientselectedDateOption?.value,
    ingredientTopCount,
  ]);

  const paramsKey = JSON.stringify(currentParams);


useEffect(() => {
  // Initial load with default filters
  IngredientTileInfo(getFilterValue(currentTab));
  lastFetchedKeyRef.current = paramsKey; // remember what we fetched
  setCurrentPage(1);

  return () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // run once on mount

const handleSearchClick = () => {
  // Only fetch if any server-side param changed since last fetch
  if (paramsKey === lastFetchedKeyRef.current) return;

  // Use the same helper to keep behavior identical
  IngredientTileInfo(
    currentParams.filter,
    Number(currentParams.table),
    currentParams.interval,
    Number(currentParams.top)
  );

  lastFetchedKeyRef.current = paramsKey;
  setCurrentPage(1);
};


const handleDateOptionChangeIngredient = (selectedOption) => {
  setIngredientSelectedDateOption(selectedOption);
  setCurrentPage(1);
};

const handleTopCountChange = (e) => {
  const newCount = Number(e.target.value);
  setIngredientTopCount(newCount);
  setCurrentPage(1);

  // No auto-fetch anymore; just clear any pending timer if you keep the ref
  if (debounceRef.current) clearTimeout(debounceRef.current);
};

const handleTabChange = (tab) => {
  setCurrentTab(tab);
  setCurrentPage(1);
};

const handleTableChange = (event) => {
  const newTable = parseInt(event.target.value, 10);
  setSelectedTable(newTable);
  setCurrentPage(1);
};

const handleSearchChange = (event) => {
  setSearchTerm(event.target.value); // client-side filter stays as-is
  setCurrentPage(1);
};


  const handleCloseModal = () => {
    setShowRecipeModal(false);
    setSelectedRecipeId(null);
    setSelectedRecipeName("");
  };


  const tabContent = (
    <div className="table-responsive">
      {/* Loading State */}
      {ingredientsLoading && (
        <div
          style={{ color: themeColor }}
          className="spinner-border d-block mx-auto"
        ></div>
      )}

      {/* Empty State */}
      {!ingredientsLoading && paginated.length === 0 && (
        <div>
          {ingredientsError
            ? `Error: ${ingredientsError}`
            : "No Records Found"}
        </div>
      )}

      {/* Data State */}
      {!ingredientsLoading && paginated.length > 0 &&
        paginated.map((product, index) => (
          <div key={index} className="mb-3 p-3 product_border">
            <div className="row">
              <div className="col-xl-8 col-12 col-md-6 col">
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="d-flex align-items-center justify-content-center me-4"
                    style={{ color: themeColor }}
                  >
                    {indexOfFirstItem + index + 1}
                  </div>
                  <div className="position-relative">
                    <Image
                      src={
                        product?.details?.baseSponsorImage || glassshimmer
                      }
                      className="bg-position-center bg-size-cover bg-repeat-no-repeat w-80px h-80px"
                    />
                  </div>
                  <div className="flex-1 ps-3">
                    <div className="fw-500 text-inverse">
                      {product?.details?.name}
                    </div>
                  </div>
                  <div className="flex-1 ms-4">
                    <label>
                      {currentTab.charAt(0).toUpperCase() + currentTab.slice(1)}:
                    </label>
                    <span className="ms-3" style={{ color: themeColor }}>
                      {product?.count ?? product?.viewCount ?? 0}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12">
                <div className="col-xl-8 col-12">
                  <div className={index < paginated.length - 1 ? "mb-2" : ""}>
                    <div className="row">
                      <div
                        className="col-xl-12 col-12"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="d-flex flex-wrap align-items-baseline">
                          <label className="me-1 mb-1">Top Cocktails:</label>
                            {product?.recipeDetails && product.recipeDetails.length > 0 ? (
                              <span
                                className="mb-1 d-flex flex-wrap"
                                style={{ minWidth: 0, flex: 1, gap: 4 }}
                                title={product.recipeDetails
                                  .map((r) => `${r.name} (${r.metricCount ?? 0})`)
                                  .join(", ")}
                              >
                                {product.recipeDetails.map((r, idx) => (
                                  <span key={r.id ?? idx}>
                                    <span
                                      style={{
                                        color: themeColor,
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        whiteSpace: "nowrap"
                                      }}
                                      onClick={() => handleCocktailClick(r)}
                                    >
                                      {r.name} ({r.metricCount ?? 0})
                                    </span>
                                    {idx < product.recipeDetails.length - 1 && <span>, </span>}
                                  </span>
                                ))}
                              </span>
                            ) : (
                              <span className="ms-2 mb-1">-</span>
                            )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );

  // Auto-fetch whenever criteria (or tab) changes
  useEffect(() => {
   IngredientTileInfo(
     currentParams.filter,
     Number(currentParams.table),
     currentParams.interval,
     Number(currentParams.top)
   );
   lastFetchedKeyRef.current = paramsKey;
   setCurrentPage(1);
   // cleanup (if you later add debouncing)
   return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
 }, [paramsKey]); // paramsKey changes when any criterion changes


  return (
    <>
      <div>
        <h6>
          <span style={{ color: themeColor }}>PAGES</span> / INGREDIENTS
        </h6>
        <div className="row">
          <div className="col-xl-8">
            <h1 className="page-header mb-0">INGREDIENTS</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <Modal show={showRecipeModal} onHide={() => setShowRecipeModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{selectedRecipeName || "Recipe Details"}</Modal.Title>
          </Modal.Header>
            <Modal.Body>
              {loadingRecipeIngredients ? (
                <div className="text-center p-4">
                  <div className="spinner-border" style={{ color: themeColor }} />
                </div>
              ) : recipeIngredientsError ? (
                <div className="alert alert-danger mb-0">
                  {recipeIngredientsError}
                </div>
              ) : recipeIngredients ? (
                <>
                  {/* ---- RECIPE IMAGE & DESCRIPTION ---- */}
                  {!Array.isArray(recipeIngredients) && (
                    <div className="text-center mb-4">
                      <img
                        src={
                          recipeIngredients.recipe?.image &&
                          recipeIngredients.recipe.image.trim() !== ""
                            ? recipeIngredients.recipe.image
                            : glassshimmer
                        }
                        alt={recipeIngredients.recipe?.name || "Recipe"}
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop
                          e.target.src = glassshimmer;
                        }}
                        style={{
                          maxWidth: "180px",
                          height: "auto",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                        }}
                      />
                    </div>
                  )}

                  {/* ---- INGREDIENTS LIST ---- */}
                  {Array.isArray(recipeIngredients) ? (
                    <>
                      <p className="mb-2"><strong>Ingredients:</strong></p>
                        <ul className="mb-0">
                          {recipeIngredients
                            .filter(ing => {
                              const ingredientName = ing.name ?? ing.ingredientName ?? "";
                              return ingredientName.trim() !== "";
                            })
                            .map((ing, i) => (
                              <li key={i}>
                                {(ing.name ?? ing.ingredientName ?? "")}{" "}
                                [
                                  {(ing.quantity ?? "")}{" "}
                                  {(!ing.unit || ing.unit === '0') ? "ML" : ing.unit}
                                ]
                              </li>
                            ))}
                        </ul>
                    </>
                  ) : (
                    <>
                      <p className="mb-2"><strong>Ingredients:</strong></p>
                      <ul className="mb-3">
                        {(recipeIngredients.ingredients ?? [])
                          .filter(ing => {
                            const ingredientName = ing.name ?? ing.ingredientName ?? "";
                            return ingredientName.trim() !== "";
                          })
                          .map((ing, i) => (
                            <li key={i}>
                              {(ing.name ?? ing.ingredientName ?? "")}{" "}
                              [
                                {(ing.quantity ?? "")}{" "}
                                {(!ing.unit || ing.unit === '0') ? "ML" : ing.unit}
                              ]
                            </li>
                          ))}
                      </ul>
                    </>

                  )}
                </>
              ) : (
                <div className="text-muted">No data available.</div>
              )}
            </Modal.Body>




          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowRecipeModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="col-12 col-md-5 mb-3">
          <ul className="nav nav-underline d-flex flex-wrap gap-2 mb-2" id="myTab" role="tablist">
            {producttabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.id}>
                <button
                  className={`nav-link ${currentTab === tab.id ? "active" : ""}`}
                  id={`${tab.id}-tab`}
                  type="button"
                  role="tab"
                  aria-selected={currentTab === tab.id}
                  onClick={() => handleTabChange(tab.id)}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-12 col-md-7">
          <div className="row g-3 align-items-end">
            <div className="col-12 col-md-3">
              <label htmlFor="date">Time Interval</label>
              <Select
                options={dateOptions}
                value={ingredientselectedDateOption}
                onChange={handleDateOptionChangeIngredient}
                classNamePrefix="react-select"
              />
            </div>

            <div className="col-12 col-md-3">
              <label className="d-block d-md-none">&nbsp;</label>
              <div className="input-group">
                <Form.Control
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Search"
                />
                  <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={handleSearchClick}
                    // Optional UX: only enable when there’s something new to fetch
                    disabled={ingredientsLoading || paramsKey === lastFetchedKeyRef.current}
                  >
                    <i className="fas fa-search"></i>
                  </button>
              </div>
            </div>

            <div className="col-12 col-md-2">
              <label>Top {ingredientselectedDateOption.desc || 'Days'}</label>
              <Form.Control
                type="number"
                min={1}
                value={ingredientTopCount}
                onChange={handleTopCountChange}
              />
            </div>

            <div className="col-12 col-md-4 d-flex align-items-center flex-wrap gap-2">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="table"
                  id="table-0"
                  value={0}
                  checked={selectedTable === 0}
                  onChange={handleTableChange}
                />
                <label className="form-check-label" htmlFor="table-0">
                  Liquor Ingredients
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="table"
                  id="table-1"
                  value={1}
                  checked={selectedTable === 1}
                  onChange={handleTableChange}
                />
                <label className="form-check-label" htmlFor="table-1">
                  Mixer Ingredients
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xl-12">
        <Card className="mt-3">
              <div style={{ right: 30, top: 10}} className="col-12 col-md-12">
              <p className="text-end mb-0">
                {getCurrentRange()} of {getTotalItems()}
              </p>
            </div>
          <CardBody>
            <div className="tab-content" id="myTabContent">
              <div
                className={`tab-pane fade show active`}
                id={currentTab}
                role="tabpanel"
                aria-labelledby={`${currentTab}-tab`}
              >
                {tabContent}
              </div>
            </div>
          </CardBody>
        </Card>

        <div className="row mt-3">
          <div className="col-md-10"></div>
          <div className="col-md-2">
            <Pagination
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              totalItems={getTotalItems()}
              paginate={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Ingredient;
